import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

// e.g. useDebouncedState(state, setState, {delay: 500});
const useDebouncedState = (input, setInput, {delay = 500}) => {
  useEffect(() => {
    const handler = setTimeout(() => {
      setInput(input);
    }, delay); // 500ms debounce
    return () => {
      clearTimeout(handler);
    };
  }, [input]);
};

export default useDebouncedState;